import React from 'react'

export default function Info2() {
  return (
    <section id='servicios' className="services-section py-16 md:py-24 bg-base-200">
      <div className="container mx-auto  md:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h1 style={{textAlign:'center'}} className="text-3xl md:text-4xl lg:text-5xl font-bold piel2">
          Cómo se Producen los Gases de Efecto Invernadero
          </h1>
        </div>
        
        <div style={{alignItems:'baseline'}} className=" ge grid grid-cols-1 md:grid-cols-4 max-w-7xl mx-auto fade-in-on-scroll">
          
          <div style={{justifySelf:'center'}} className="card2   w-full">
            <div className="card-body">
                <img src='img/4.webp' />
              <h2 className="titulo piel">Consumo Energético</h2>
              <p className='piel2'>El uso de energía en hogares y edificios para calefacción, refrigeración e iluminación contribuye significativamente a las emisiones de GEI.</p>
           
            
            </div>
          </div>

          <div style={{justifySelf:'center'}} className="card2   w-full">
            <div className="card-body">
                <img src='img/3.webp' />
              <h2 className="titulo piel">Combustibles Fósiles</h2>
              <p className='piel2'>La quema de carbón, petróleo y gas natural para obtener energía libera grandes cantidades de CO2.</p>
            
            
            </div>
          </div>

          <div style={{justifySelf:'center'}} className="card2   w-full">
            <div className="card-body">
                <img src='img/6.webp' />
              <h2 className="titulo piel">Agricultura</h2>
              <p className='piel2'>Prácticas agrícolas como la ganadería y el cultivo de arroz emiten metano (CH4) y óxido nitroso (N2O).</p>
          
            
            </div>
          </div>

          <div style={{justifySelf:'center'}} className="card2   w-full">
            <div className="card-body">
                <img src='img/5.webp' />
              <h2 className="titulo piel">Deforestación</h2>
              <p className='piel2'>La tala de árboles reduce la capacidad del planeta para absorber CO2.</p>
           
            
            </div>
          </div>

          <div style={{justifySelf:'center'}} className="card2   w-full">
            <div className="card-body">
                <img src='img/7.webp' />
              <h2 className="titulo piel">Industria</h2>
              <p className='piel2'>Diversos procesos industriales liberan gases de efecto invernadero.</p>
           
            
            </div>
          </div>

          <div style={{justifySelf:'center'}} className="card2   w-full">
            <div className="card-body">
                <img src='img/2.webp' />
              <h2 className="titulo piel">Residuos</h2>
              <p className='piel2'>La descomposición de residuos orgánicos en los vertederos genera metano.</p>
           
            
            </div>
          </div>

          <div style={{justifySelf:'center'}} className="card2   w-full">
            <div className="card-body">
                <img src='img/1.webp' />
              <h2 className="titulo piel">Transporte</h2>
              <p className='piel2'>La quema de combustibles fósiles para el transporte, como automóviles, aviones y barcos, es una fuente importante de emisiones de GEI.</p>
           
            
            </div>
          </div>

          

          

          
          

          
        </div>
        
      </div>
    </section>
  )
}
